import { DVACardType } from './DVACardType';

export interface IDVA {
  hasDept: boolean;
  cardType: DVACardType;
  cardNumber: number;
}

/* eslint-disable  no-unused-vars */
export enum CARD_TYPES {
  MEDICARE='medicare',
  DVA='dva',
  NONE='none',
}

export interface MedicareCard {
  medicareCardNumber?: string; // 3577664477,
  medicareCardIRN?: string; // 1
  expiry?: string;
  dva?: IDVA;
  cardType: CARD_TYPES ;
}
